module.exports = __webpack_public_path__ + "img/productFea1.8fbf3ca1.png";